exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "i[data-v-d0c5286e]{width:1em;display:inline-block;color:#9e9e9e}i.active[data-v-d0c5286e]{color:#fbc02d}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/Stars.vue"],"names":[],"mappings":"AACA,mBACE,UAAW,AACX,qBAAsB,AACtB,aAAe,CAChB,AACD,0BACE,aAAe,CAChB","file":"Stars.vue","sourcesContent":["\ni[data-v-d0c5286e] {\n  width: 1em;\n  display: inline-block;\n  color: #9e9e9e;\n}\ni.active[data-v-d0c5286e] {\n  color: #fbc02d;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d0c5286e","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Stars.vue
// module id = 859
// module chunks = 0 7